import { useMutation } from '@tanstack/react-query';
import { endpoints, Url } from '@rossum/api-client';
import { EvaluateRulesResponse } from '@rossum/api-client/internal';
import { QueueRule } from '@rossum/api-client/schemas';
import { useApiClient } from '../../../lib/apiClient';

type ValidateRuleParams = {
  rule: Partial<QueueRule>;
  queues: Url[];
};

export type ValidationErrorsPerQueue = {
  queue: Url;
  errors: EvaluateRulesResponse['messages'];
};

export const useValidateRuleAgainstQueues = () => {
  const api = useApiClient();

  return useMutation({
    mutationFn: async ({
      rule,
      queues,
    }: ValidateRuleParams): Promise<ValidationErrorsPerQueue[]> => {
      const errors = await Promise.all(
        queues.map(queue =>
          api
            .request(
              endpoints.internal.rules.evaluateRules({
                queue,
                schemaRules: [rule],
                // No annotationContent = static validation mode
              })
            )
            .then(result => ({
              queue,
              errors: result.messages.filter(ms => ms.type === 'error'),
            }))
        )
      );

      return errors;
    },
  });
};
